import { render, staticRenderFns } from "./PaymentPix.vue?vue&type=template&id=9ed7fb8e&scoped=true&"
import script from "./PaymentPix.vue?vue&type=script&lang=js&"
export * from "./PaymentPix.vue?vue&type=script&lang=js&"
import style0 from "./PaymentPix.vue?vue&type=style&index=0&id=9ed7fb8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed7fb8e",
  null
  
)

export default component.exports